export default "__VITE_ASSET__CrbjeoaM__"